import React from 'react';
import { StyledLink } from '../StyledComponents';
import { FormattedMessage } from 'react-intl';
import { isBitbucket } from 'util/mac/helpers';
import { StyledPipe } from './StyledPipe';

export const ProductAdminLink = ({
  productKey,
  hasExternalUuid,
  accountName,
  domain,
}: {
  productKey: string;
  hasExternalUuid: boolean;
  accountName: string;
  domain: string;
}) => (
  <>
    <StyledLink
      href={
        isBitbucket(productKey)
          ? `https://bitbucket.org/account/user/${accountName}/`
          : `https://${accountName}.${domain}/admin/billing/applications`
      }
      data-cy={`actions-section-${
        hasExternalUuid ? 'manage-subscriptions' : 'configure-products-and-users'
      }-button`}
    >
      <FormattedMessage
        id={`mac.licenses.${
          hasExternalUuid ? 'manage-subscriptions' : 'configure-products-and-users'
        }`}
        defaultMessage={hasExternalUuid ? 'Manage subscriptions' : 'Configure Products & Users'}
      />
    </StyledLink>
    <StyledPipe />
  </>
);
